import * as React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@shared/components/button';
import { Modal } from '@shared/components/modal';
import { useModals } from '@shared/contexts/modal-context';

import partyPopperImage from '@assets/images/party_popper.webp';

import { ModalName } from '../types';
import * as Styled from './join-race-confirm-modal.styled';

export interface JoinRaceConfirmModalData {
	raceName: string;
}

const JoinRaceConfirmModal = () => {
	const { t  } = useTranslation('coin_race_details');
	const { isModalOpen, closeModal, getModalData } = useModals();

	const modalData = getModalData<JoinRaceConfirmModalData>(ModalName.JOIN_RACE_CONFIRM);

	const handleClose = React.useCallback(() => {
		closeModal();
	}, [closeModal]);

	if (!modalData) {
		return null;
	}

	const title = (
		<Styled.TitleContainer>
			<Styled.TitleImage src={partyPopperImage} alt="Party" />
			{t('congratulations')}
		</Styled.TitleContainer>
	);

	return (
		<Modal isOpen={isModalOpen(ModalName.JOIN_RACE_CONFIRM)} title={title} closeModal={closeModal}>
			<Styled.Wrapper>
				<Styled.Message>
					<Trans
						ns='coin_race_details'
						i18nKey='modals.join_success'
						values={{ raceName: modalData.raceName }}
						components={{ strong: <strong /> }}
					/>
				</Styled.Message>

				<Styled.Footer>
					<Button onClick={handleClose} color='dark'>
						{t('close')}
					</Button>
				</Styled.Footer>
			</Styled.Wrapper>
		</Modal>
	);
};

export default JoinRaceConfirmModal;
